/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phone_VerifiedInputs */



/**
* | output |
* | --- |
* | "Your phone number has been verified successfully" |
*
* @param {Phone_VerifiedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_verified = /** @type {((inputs?: Phone_VerifiedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_VerifiedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Your phone number has been verified successfully")
	return /** @type {LocalizedString} */ ("Votre numéro de téléphone a été vérifié avec succès")
});